import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { FilterMatchMode } from 'primereact/api';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import '../config.js';
import { ScrollTop } from 'primereact/scrolltop';
import { ProgressBar } from 'primereact/progressbar';   
import { Messages } from 'primereact/messages';
import { Tag } from 'primereact/tag';
import useStatusPageScript from '../hooks/useStatusPageScript.js';
import { Dialog } from 'primereact/dialog';
import { Toolbar } from 'primereact/toolbar';
import { Dropdown } from 'primereact/dropdown';
import Login from './Login.js';
import { Toast } from 'primereact/toast';

const SupportClients = () => {
  // Load the status page script
  useStatusPageScript();
  
  const { id } = useParams();
  const [events, setEvents] = useState([]);
  const navigate = useNavigate();
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    tiles: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState(20);
  const msgs = useRef(null);
  const testmsgs  = useRef(null);
  const [troubleShootDialog, setTroubleShootDialog] = useState(false);
  const [lms, setLms] = useState('the LMS');
  const [helpOnline, setHelpOnline] = useState(false);
  const [helpOffline, setHelpOffline] = useState(false);
  const [helpTestTrueHR, setHelpTestTrueHR] = useState(false);
  const [helpTestTrueNor, setHelpTestTrueNor] = useState(false);
  const [helpTestFalse, setHelpTestFalse] = useState(false);
  const [helpOnlineCheckin, setHelpOnlineCheckin] = useState(false);
  const [memberTest, setMemberTest] = useState('');
  const [tiles, setTiles] = useState([]);
  const [tileId, setTileId] = useState('');
  const [isLmsAPI, setIsLmsAPI] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [appid, setAppId] = useState(0);
  const [useAppId, setUseAppId] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const toast = useRef(null);
  const [cid, setCid] = useState(0);

  const handleLoginSuccess = () => {
      setShowLoginModal(false);
      if (toast.current) {
          toast.current.show({severity: 'success', summary: '', detail: 'Login successful! You can continue working.'});
      }
      getEvents(rows, 0);
  };

  useEffect(() => {
    const fetchEvents = async () => {
        getEvents(rows,0);
    };

    let appid = localStorage.getItem('appid');
    if(appid !== null){
      setAppId(appid);
      setUseAppId(true);
    }
    let id = localStorage.getItem('id');
    if(id !== null){
      setCid(id);
      console.log('Cid is ' + id);
    }
    fetchEvents();

    let _filters = JSON.parse(localStorage.getItem('clients-global'));
    if (_filters) {
      setFilters(_filters);
      setGlobalFilterValue(_filters['global'].value);
    }

    // Set up interval for refreshing clients every 10 seconds
    const interval = setInterval(() => {
      refreshClients();
    }, 10000);

    // Cleanup function to clear interval when component unmounts
    return () => {
      clearInterval(interval);
    };
  }, [id]);


  const refreshClients = async () => {
    const token = localStorage.getItem('token');
    const id = localStorage.getItem('id');
    const locationame = localStorage.getItem('supportsite');
    let url = global.config.url + `/support/clients/${locationame}/${id}`;
    let appid = localStorage.getItem('appid');
    if(appid !== null || useAppId){
      url = url + `?appProviderId=${appid}`;
    }
    if (!locationame) {
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select a site first.'});
      setLoading(false);
      navigate('/support/sites');
      return;
    }
    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        setEvents(response.data);
      }
      else {
        setEvents([]);
      }
    } catch (error) {
    }
  };

  const getEvents = async () => {
    try {
        setLoading(true);
        setEvents([]);
        const token = localStorage.getItem('token');
        const id = localStorage.getItem('id');
        const locationame = localStorage.getItem('supportsite');
        let url =  global.config.url + `/support/clients/${locationame}/${id}`;
        let appid = localStorage.getItem('appid');
        if(appid !== null || useAppId){
          url = url + `?appProviderId=${appid}`;
        }
        if (!locationame) {
          msgs.current.show({severity: 'error', summary: '', detail: 'Please select a site first.'});
          setLoading(false);
          navigate('/support/sites');
          return;
        }
        const response = await axios.get(url, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          let urlLms = global.config.url + `/support/lms/${id}`;
          if(appid !== null || useAppId){
            urlLms = urlLms + `?appProviderId=${appid}`;
          }
          const lms = await axios.get(urlLms, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          if (lms.status === 200) {
            setLms(lms.data.key);
            setIsLmsAPI(!lms.data.value);
          }
          setEvents(response.data);
          setLoading(false);
      } catch (error) {
        console.error('Error fetching event record:', error);
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            setShowLoginModal(true);
          }
          setLoading(false);
          setEvents([]);
      }
      

    };


  // const onPageChange = (event) => {
  //   setLoading(true);
  //   setRows(event.rows);
  //   getEvents(event.rows, event.page);
  // };
  
  const optionsSelected = (e, rowdata) =>{
      // op.current.toggle(e);
      // console.log(e.value);
      // console.log(rowdata);
      setRowSelectionModel(rowdata);
      // setShowOptions(true);
    }

  // const optionsTemplate = (rowData) => {
  //   return <Button link icon="pi pi-ellipsis-v" onClick={(e) => optionsSelected(e, rowData)} />;
  // };

  //   const helpTemplate = (rowData) => {
  //   return <Button link icon="pi pi-question-circle" onClick={(e) => getHelp(e, rowData)} />;
  // };

    const getAccessPoints = async () => {
    if(rowSelectionModel[0] === undefined || rowSelectionModel[0].id === 0 || rowSelectionModel[0].name === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select a client to view its tiles.'});
    }
    else{
      // navigate(`/accesspoints/client/${rowSelectionModel.name}/${rowSelectionModel.id}`);
      // msgs.current.show({severity: 'info', summary: '', detail: rowSelectionModel.name + ' access points are not yet implemented.'});
      const siteName = localStorage.getItem('supportsite');
      localStorage.setItem('supporttile', `${rowSelectionModel[0].name}/${siteName}`);
      localStorage.setItem('tilesfrom', 'clients'); 
      navigate(`/support/tiles/`);
    }
  }

  const getClientLogs = async () => {
        if(rowSelectionModel[0] === undefined || rowSelectionModel[0].id === 0 || rowSelectionModel[0].name === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select a client to view its logs.'});
    }
    else{
      // navigate(`/accesspoints/client/${rowSelectionModel.name}/${rowSelectionModel.id}`);
      // msgs.current.show({severity: 'info', summary: '', detail: rowSelectionModel.name + ' client logs are not yet implemented.'});
      localStorage.setItem('supportclient', rowSelectionModel[0].name);
      navigate(`/support/clientlogs/`);
    }
  }

  const getClientStatusLogs = async () => {
    if(rowSelectionModel[0] === undefined || rowSelectionModel[0].id === 0 || rowSelectionModel[0].name === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select a client to view its status logs.'});
    }
    else{
      const selectedClient = rowSelectionModel[0].name;
      const selectedLocation = localStorage.getItem('supportsite');
      const selectedCustomerId = localStorage.getItem('id');

      localStorage.setItem('supportclientstatus_clientname', selectedClient);
      if (selectedLocation !== null && selectedLocation !== undefined) {
        localStorage.setItem('supportclientstatus_locationname', selectedLocation);
      }
      if (selectedCustomerId !== null && selectedCustomerId !== undefined) {
        localStorage.setItem('supportclientstatus_customerid', selectedCustomerId);
      }

      navigate('/support/clientstatuslogs');
    }
  }

  const setClientToRestart = async () => {
    if(rowSelectionModel[0] === undefined || rowSelectionModel[0].id === 0 || rowSelectionModel[0].name === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select a client to set to restart.'});
    }
    else{
      try {
        const token = localStorage.getItem('token');
        const id = localStorage.getItem('id');
        const locationame = localStorage.getItem('supportsite');
        let url = global.config.url + `/support/clients/restartclient/${rowSelectionModel[0].name}/${locationame}/${id}`;
        if(useAppId){
          url = url + `?appProviderId=${appid}`;
        }
        const response = await axios.get(url, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          if(response.status === 200){
            msgs.current.show({severity: 'success', summary: '', detail: `Client ${rowSelectionModel[0].name} successfully set to restart.`});
          }
          else{
            if(response.data && response.data){
              msgs.current.show({severity: 'error', summary: '', detail: response.data});
              setShowOptions(false);
              return;
            }
            msgs.current.show({severity: 'error', summary: '', detail: 'Error setting client to restart.'});
          }
      } catch (error) {
        console.error('Error setting client to restart:', error);
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            setShowLoginModal(true);
          }
          if(error.response && error.response.data && error.response.data){
            msgs.current.show({severity: 'error', summary: '', detail: error.response.data});
            setShowOptions(false);
            return;
          }
          msgs.current.show({severity: 'error', summary: '', detail: 'Error setting client to restart.'});
      }
    }
    setShowOptions(false);
  }

  const copyClientToClipboard = async (client) => {
    if(client === null || client === undefined){
      if(rowSelectionModel[0] === undefined || rowSelectionModel[0].id === 0 || rowSelectionModel[0].name === null){
        msgs.current.show({severity: 'error', summary: '', detail: 'Please select a client to copy.'});
      }
      else{
        navigator.clipboard.writeText(rowSelectionModel[0].name);
        msgs.current.show({severity: 'success', summary: '', detail: `Client ${rowSelectionModel[0].name} copied to clipboard.`});
      }
      setShowOptions(false);
    }else{
      navigator.clipboard.writeText(client.name);
      //delay to allow message to show before closing options
      await new Promise(resolve => setTimeout(resolve, 5));
      setShowOptions(false);
      msgs.current.show({severity: 'success', summary: '', detail: `Client ${client.name} copied to clipboard.`});
    }
  }
  const startContent = (
      <React.Fragment>
        <div>
          <Button onClick={() => getAccessPoints()} label="Get Tiles" icon="pi pi-qrcode" className="p-button-success mb-3 ml-3" tooltip="Get tiles for this location" tooltipOptions={{position:"bottom"}}/>
          <Button onClick={() => getClientLogs()} label="Get Client Logs" icon="pi pi-file" className="p-button mb-3 ml-3" tooltip="Get the logs for this client" tooltipOptions={{position:"bottom"}}/>
          <Button onClick={() => getClientStatusLogs()} label="Get Status Logs" icon="pi pi-clock" className="p-button-help mb-3 ml-3" tooltip="Get status logs for this client" tooltipOptions={{position:"bottom"}}/>
          <Button onClick={() => setClientToRestart()} label="Set to Restart" icon="pi pi-refresh" className="p-button-danger mb-3 ml-3" tooltip="Set this client to restart" tooltipOptions={{position:"bottom"}}/>
        </div>
        <div>
          <Button label='Troubleshoot' icon="pi pi-wrench" className="p-button-secondary mb-3 ml-3" onClick={() => getHelp()}  tooltip='Troubleshoot this client' tooltipOptions={{position:"bottom"}}/>
          {(lms === "Gladstone" || lms === "Legend") && (<Button label="Advanced Troubleshoot" icon="pi pi-plus" className="p-button-warning mb-3 ml-3" onClick={() => setTroubleShootDialog(true)} tooltip="Open Advanced Troubleshoot guide" tooltipOptions={{position:"bottom"}}/>)}
          <Button label="Copy Client Name" icon="pi pi-copy" className="p-button-info mb-3 ml-3" onClick={() => copyClientToClipboard()} tooltip="Copy client name to clipboard" tooltipOptions={{position:"bottom"}}/>
        </div>
      </React.Fragment>
  );

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters['global'].value = value;

    localStorage.setItem('clients-global', JSON.stringify(_filters));

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const clearFilter = () => {
  let _filters = { ...filters };
  _filters['global'].value = null;
  setFilters(_filters);
  setGlobalFilterValue('');
  localStorage.removeItem('clients-global');
};

  const getSeverity = (client) => {
    switch (client.status) {
        case "Online":
            return 'success';

        case "Offline":
            return 'danger';

        default:
            return null;
    }
  };
  const statusBodyTemplate = (client) => {
      return <Tag value={client.status} severity={getSeverity(client)}></Tag>;
  };

      const goBack = () => {
      localStorage.removeItem('clients-global');
      navigate(-1);
    }

  const progressbar = (        
    <div className="card mt-3">
        <ProgressBar mode="indeterminate" style={{ height: '6px' }}></ProgressBar>
    </div>);

const openHubRelay = () => {
  msgs.current.show({severity: 'info', summary: '', detail: 'Hub and Relay are not yet implemented.'});
}
const testMember = async () => {
  if(memberTest === ''){
    msgs.current.show({severity: 'error', summary: '', detail: 'Please enter a member name to test.'});
  }
  else{
    testmsgs.current.show({severity: 'info', summary: '', detail: `Testing member ${memberTest}...`});
    // Here you would implement the logic to test the member
    const token = localStorage.getItem('token');
    const id = localStorage.getItem('id');
    let url = global.config.url + `/support/testmember/${tileId}/${memberTest}/${id}`;
    if(useAppId){
      url = url + `?appProviderId=${appid}`;
    }
    try {
    const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      if(response.status === 200){
        if(response.data === true){
            msgs.current.show({severity: 'success', summary: '', detail: 'Access allowed by lms.'});
            setHelpTestFalse(false);
            let urlhresp = global.config.url + `/support/hubsrelay/${tileId}/${id}`;
            if(useAppId){
              urlhresp = urlhresp + `?appProviderId=${appid}`;
            }
            const hresp = await axios.get(urlhresp, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          if (hresp.status === 200) {
            if(hresp.data.length > 0){
              localStorage.setItem('tileid', tileId);
              // navigate(`/support/hubrelay`);
              setHelpTestTrueHR(true);
            }
            else{
              setHelpTestTrueNor(true);
            }
          }
          else{
            setHelpTestTrueNor(true);
          }
        }
        else if(response.data === false){
            msgs.current.show({severity: 'error', summary: '', detail: 'Either access is denied for this member or we could not connect with LMS.'});
            setHelpTestFalse(true);
        }
        else{
            testmsgs.current.clear();
            testmsgs.current.show({severity: 'warn', summary: '', detail: 'Error testing this tile.'});
        }
      }
      else{
        testmsgs.current.clear();
        testmsgs.current.show({severity: 'warn', summary: '', detail: 'Error testing this tile.'});
      }
    } catch (error) {
      console.error('Error testing member:', error);
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          showLoginModal(true);
        }
        testmsgs.current.clear();
        testmsgs.current.show({severity: 'warn', summary: '', detail: 'Error testing this tile.'});
    }
  }
}
  const getHelp = async () => {
    if(rowSelectionModel[0] === undefined || rowSelectionModel[0].id === 0 || rowSelectionModel[0].name === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select a client to get help.'});
    }
    else{
        if(rowSelectionModel[0].status === 'Online' || isLmsAPI){ 

          const token = localStorage.getItem('token');
          const id = localStorage.getItem('id');
          const si = localStorage.getItem('supportsite');
          if(lms === 'Gladstone') {
            let urlCheckin = global.config.url + `/support/ischeckinclient/${rowSelectionModel[0].name}/${id}`;
            if(useAppId){
              urlCheckin = urlCheckin + `?appProviderId=${appid}`;
            }
            const ischeckin = await axios.get(urlCheckin, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            });

            if (ischeckin.status === 200) {
              if(ischeckin.data === true){
                setHelpOnlineCheckin(true);
                return;
              }
            }
          }
          setHelpOnline(true);
          let url = global.config.url + `/support/tiles/clients/${rowSelectionModel[0].name}/${si}/${id}`;
          if(useAppId){
            url = url + `?appProviderId=${appid}`;
          }
          try {
            const response = await axios.get(url, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            });
            if (response.status === 200) {
              let til = [];
              for (let i = 0; i < response.data.length; i++) {
                til.push({label: response.data[i].gateName, value: response.data[i].tileId});
              }
              setTiles([...new Set(til)]);
              setTileId(response.data[0].tileId);
            } else {
              msgs.current.show({severity: 'error', summary: '', detail: 'Error getting tiles for this client.'});
              setHelpOnline(false);
            }
          } catch (error) {
            console.error('Error getting tiles for client:', error);
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                setShowLoginModal(true);
              }
            msgs.current.show({severity: 'error', summary: '', detail: 'Error getting tiles for this client.'});
            setHelpOnline(false);
          }
        }
        else{
          setHelpOffline(true);
        }
      
    }
    
  }
    const copyClientsTemplate = (rowData) => {
      return <Button link icon="pi pi-copy" tooltip="Copy client name to clipboard" tooltipOptions={{position:"bottom"}} onClick={(e) => copyClientToClipboard(rowData)}/>;
    };

  return (
    <Card className='justify-content-md-center mt-5'>
      <Container fluid="md" >
      <div className="panel">
        <div className="flex align-content-center flex-wrap">
          <Button link icon="pi pi-arrow-left" onClick={() => goBack()} className='flex mb-3'/> 
          <h4 className='flex mt-2 mb-3'>Clients for {localStorage.getItem("supportsite")}</h4> 
          <span className="p-input-icon-left mb-3 ml-3">
            <i className="pi pi-search" />
            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Filter Search" tooltip="Start typing to filter" 
              tooltipOptions={{position: "bottom"}}/>
          </span>
          <Button icon="pi pi-times" className="p-button-text mb-3"  onClick={() => clearFilter()} tooltip="Clear filter" tooltipOptions={{position: "bottom"}} />
        </div>
        {/* <Toolbar           
        start={

        } 
        end = {        
          }/> */}
      </div>
      {loading && progressbar}
        <Messages ref={msgs} />
        <Toast ref={toast} />
        <Row className='justify-content-md-center mt-5'>
            <Col>
            <Dialog visible={showOptions} onHide={() => setShowOptions(false)} style={{ minWidth: '5rem' }}>
            {startContent}
          </Dialog>
            <DataTable value={events} selectionMode={'radiobutton'} selection={rowSelectionModel} onSelectionChange={(e) => optionsSelected(e, e.value)} 
            onClick={(e) => setShowOptions(true)}
            dataKey="name" tableStyle={{ minWidth: '50rem' }} filters={filters} filterDisplay="menu" emptyMessage={loading ? "Loading clients..." : "No clients found."}
            globalFilterFields={['name', 'tiles', 'status']}  
            scrollable scrollHeight="60vh">
                {/* <Column field="options" header="" body={optionsTemplate}> </Column> */}
                <Column field="copy" header="" body={copyClientsTemplate}> </Column>
                <Column field="name" header="Name" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} style={{ minWidth: '12rem' }} sortable></Column>
                <Column header="Status" body={statusBodyTemplate} ></Column>
                <Column field="tiles" header="Tiles" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} style={{ minWidth: '12rem' }} sortable></Column>
                <Column field="version" header="Client Version" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} style={{ minWidth: '12rem' }} sortable></Column>
            </DataTable>
            </Col>
        
        </Row>

          <div className="card flex justify-content-center">
            <Dialog className='justify-content-center' visible={troubleShootDialog} onHide={() => setTroubleShootDialog(false)} style={{ minWidth: '5rem' }}>
            <div className="card">
              <Toolbar className='' start={<h4>Troubleshoot guide</h4>}/>
              </div>
            <div className='justify-content-md-center mt-5'>
              <React.Fragment>
                <ul>
                <li> Got to C:\ProgramData\CCTech\SmartTile\Client\st-event.log and check that Smart Tile is receiving the scans if not, restart Smart Tile Client service. </li>
                  <li>If Smart Tile still does not receive the scans, check the network connection and that SmartTile server's URL has been added to the Firewall (http://mfapi.smarttile.co.uk). </li>
                  <li> If Smart Tile is receiving the scans but not getting into {lms} please restart {lms}.</li>
                  <li> If after restarting {lms} it still does not receive the scans. Check that the cables are correctly connected. </li>
                  <li> If they are, please check the COM ports in Device Manager match with the one set in {lms} and the ones set in Smart Tile (<a href='/support/tiles'>see tiles page</a> for more details).</li>
                  <li> Another good practice would be to restart the PC in case the COM ports are frozen.</li>
                  <li> If {lms} is receiving the scans correctly but the gate is not opening, check that we are receiving the open gate commands in C:\ProgramData\CCTech\SmartTile\Client\st-event.log.</li>
                  <li> If we are not receiving them restart Smart Tile Client and/or check the access rules in {lms}.</li>
                  <li> If we are receiving them, there could be a problem with the controller, check that it is running correctly; if hub and relay please hub and relays status for these clients <a href="#" onClick={() => openHubRelay()}>here</a>.</li>
                  {appid == 2 && (<li> If the problem persists, please use the ‘live chat function’ in your app's Cockpit. Click here for instructions on how to do this - <a href="https://eur06.safelinks.protection.outlook.com/?url=https%3A%2F%2Frb.gy%2Flbwdhi&data=05%7C02%7Cmatt%40innovatise.com%7Cf199dfb149f74d94670708dd200b11bd%7C791dcfc4e7f34e3988270ba4d9b33c8e%7C0%7C0%7C638701954098698861%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=U22nSxVAQIMw1rRl6dw0rCR5J3sx1vn8jrgz%2BxBLkR0%3D&reserved=0" target="_blank">Click here for instructions</a> </li>)}
                  {appid != 2 && (<li> If the problem persists, please contact support@smarttile.co.uk </li>)}
                </ul>
                {/* <Button label="Open Support Ticket" icon="pi pi-ticket" className="p-button-success mb-3 ml-3" onClick={() => navigate('/support/tickets/create')} tooltip="Open a support ticket for this client" tooltipOptions={{position:"bottom"}}/> */}
              </React.Fragment>
            </div>
            </Dialog>
            <Dialog className='justify-content-center' visible={helpOnline} onHide={() => setHelpOnline(false)} style={{ minWidth: '5rem' }}>
            <div className="card">
              <Toolbar className='' start={<h4>Troubleshoot online client</h4>}/>
              </div>
            <div className='justify-content-md-center mt-5'>
              <Messages ref={testmsgs} />
              <React.Fragment>
                <p> If the PC appears online check if scans are appearing in {lms}</p>
                {/* <Dropdown placeholder="Select tile" options={tiles} optionLabel="name" optionValue="gatename" className="mb-3" onChange={(e) => setTileId(e.tileId)} /> */}
                <div className='mt-3' >
                <Dropdown id="selectTile" name="selectTiles" value={tileId} options={tiles} 
                onChange={(e) => setTileId(e.value)} placeholder="Select Tile to Test" tooltip="Select Tile to Test"
                />
                </div>
                <div className='mt-3'>
                <InputText value={memberTest} onChange={(e) => setMemberTest(e.target.value)} placeholder="Enter member name to test"/>
                </div>
                <div className='mt-3'>
                <Button label="Test Member" icon="pi pi-check" className="p-button-success" onClick={() => {testMember()}} tooltip="Test member access" tooltipOptions={{position:"bottom"}}/>

                </div>
                {/* <Button label="Open Support Ticket" icon="pi pi-ticket" className="p-button-info mt-3" onClick={() => navigate('/support/tickets/create')} tooltip="Open a support ticket for this client" tooltipOptions={{position:"bottom"}}/> */}
              </React.Fragment>
            </div>
            </Dialog>
            <Dialog className='justify-content-center' visible={helpOffline} onHide={() => setHelpOffline(false)} style={{ minWidth: '5rem' }}>
            <div className="card">
              <Toolbar className='' start={<h4>Troubleshoot guide offline client</h4>}/>
              </div>
            <div className='justify-content-md-center mt-5'>
              <React.Fragment>
                <ul>
                  <li> Check PC is on and connected to Internet.</li>
                  <li>Check the network connection and that SmartTile server's URL has been added to the Firewall (http://mfapi.smarttile.co.uk).</li>
                  <li> Restart Smart Tile Client.</li>
                  <li> Another option is to restart the PC.</li>
                  {appid == 2 && (<li> If the problem still persists, please use the ‘live chat function’ in your app's Cockpit. Click here for instructions on how to do this - <a href="https://eur06.safelinks.protection.outlook.com/?url=https%3A%2F%2Frb.gy%2Flbwdhi&data=05%7C02%7Cmatt%40innovatise.com%7Cf199dfb149f74d94670708dd200b11bd%7C791dcfc4e7f34e3988270ba4d9b33c8e%7C0%7C0%7C638701954098698861%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=U22nSxVAQIMw1rRl6dw0rCR5J3sx1vn8jrgz%2BxBLkR0%3D&reserved=0" target="_blank">Click here for instructions</a></li>)}
                  {appid != 2 && (<li> If the problem still persists, please contact support@smarttile.co.uk </li>)}
                </ul>
                {/* <Button label="Open Support Ticket" icon="pi pi-ticket" className="p-button-success mb-3 ml-3" onClick={() => navigate('/support/tickets/create')} tooltip="Open a support ticket for this client" tooltipOptions={{position:"bottom"}}/> */}
              </React.Fragment>
            </div>
            </Dialog>
                        <Dialog className='justify-content-center' visible={helpOnlineCheckin} onHide={() => setHelpOnlineCheckin(false)} style={{ minWidth: '5rem' }}>
            <div className="card">
              <Toolbar className='' start={<h4>Troubleshoot guide</h4>}/>
              </div>
            <div className='justify-content-md-center mt-5'>
              <React.Fragment>
                <ul>
                  <li> Restart Smart Tile Client service and {lms}.</li>
                  <li> Another option is to restart the PC.</li>
                  <li> Check if the scans appear in {lms}.</li>
                  <li> If the scans do not appear in {lms} check the COM ports in Device Manager match with the one set in {lms} and the ones set in Smart Tile (<a href='/support/tiles'>see tiles page</a> for more details).</li>
                  {appid == 2 && (<li> If the problem still persists, please use the ‘live chat function’ in your app's Cockpit. Click here for instructions on how to do this - 
                    <a href="https://eur06.safelinks.protection.outlook.com/?url=https%3A%2F%2Frb.gy%2Flbwdhi&data=05%7C02%7Cmatt%40innovatise.com%7Cf199dfb149f74d94670708dd200b11bd%7C791dcfc4e7f34e3988270ba4d9b33c8e%7C0%7C0%7C638701954098698861%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=U22nSxVAQIMw1rRl6dw0rCR5J3sx1vn8jrgz%2BxBLkR0%3D&reserved=0" target="_blank">Click here for instructions</a></li>)}
                  {appid != 2 && (<li> If the problem still persists, please contact support@smarttile.co.uk </li>)}
                </ul>
                {/* <Button label="Open Support Ticket" icon="pi pi-ticket" className="p-button-success mb-3 ml-3" onClick={() => navigate('/support/tickets/create')} tooltip="Open a support ticket for this client" tooltipOptions={{position:"bottom"}}/> */}
                
              </React.Fragment>
            </div>
            </Dialog>
            <Dialog className='justify-content-center' visible={helpTestFalse} onHide={() => setHelpTestFalse(false)} onOpenChange={(open) => {
              if (!open) navigate('support/tiles'); // close dialog
            }} style={{ minWidth: '5rem' }}>
            <div className="card">
              <Toolbar className='' start={<h4>either access is denied for this member or we could not connect with LMS</h4>}/>
              </div>
            <div className='justify-content-md-center mt-5'>
              <React.Fragment>
                <p> The test was not successful, please restart Smart Tile Client service and {lms} and try again, if still not successful, see below:</p>
                <ul>
                  <li> Check if the scan appeared in {lms}.</li>
                    <ul>
                     { !isLmsAPI && (<li> If not please run the installer and make sure that the COM ports are correctly setup according device manager and check that the slave/gate number match with the ones set in {lms}.</li>)} 
                    { isLmsAPI && (<li> If not please check the <a href='/support/clientlogs'>logs</a> to see if we have received the scan and then let us know.</li>)}
                    </ul>
                  <li> If the scan appeared in {lms} but access denied.</li>
                  <ul>
                    <li> Check the access rules for this member are correctly setup.</li>
                  </ul>
                </ul>
                {appid == 2 && (<p> If the issue persists, please use the ‘live chat function’ in your app's Cockpit. Click here for instructions on how to do this - <a href="https://eur06.safelinks.protection.outlook.com/?url=https%3A%2F%2Frb.gy%2Flbwdhi&data=05%7C02%7Cmatt%40innovatise.com%7Cf199dfb149f74d94670708dd200b11bd%7C791dcfc4e7f34e3988270ba4d9b33c8e%7C0%7C0%7C638701954098698861%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=U22nSxVAQIMw1rRl6dw0rCR5J3sx1vn8jrgz%2BxBLkR0%3D&reserved=0" target="_blank">Click here for instructions</a></p>)}
                {appid != 2 && (<p> If the issue persists, please contact support@smarttile.co.uk </p>)}
                {/* <Button label="Open Support Ticket" icon="pi pi-ticket" className="p-button-success mb-3 ml-3" onClick={() => navigate('/support/tickets/create')} tooltip="Open a support ticket for this client" tooltipOptions={{position:"bottom"}}/> */}
              </React.Fragment>
            </div>
            </Dialog>
            <Dialog className='justify-content-center' visible={helpTestTrueNor} onHide={() => setHelpTestTrueNor(false)} style={{ minWidth: '5rem' }}>
            <div className="card">
              <Toolbar className='' start={<h4>Test successful</h4>}/>
              </div>
            <div className='justify-content-md-center mt-5'>
              <React.Fragment>
                <p> The test was successful, please check that it has released the gate. </p>
                <p> If the gate did not release, please use the URI test to test if the door controller releases and, also, to check the slave number that triggers the gate.</p>
                <p> If the slave number is different that the one set for this accesspoint, you can change it in our end using the installer and you might also need to change it in {lms}.</p>
              </React.Fragment>
            </div>
            </Dialog>
            <Dialog className='justify-content-center' visible={helpTestTrueHR} onHide={() => setHelpTestTrueHR(false)} style={{ minWidth: '5rem' }}>
            <div className="card">
              <Toolbar className='' start={<h4>Test successful</h4>}/>
              </div>
            <div className='justify-content-md-center mt-5'>
              <React.Fragment>
                <p> The test was successful, please check that it has released the gate. </p>
                <p> If the gate did not release, please check if the hub and/or relay are online.</p>
                <p> You can check if the hub and/or the relay are online <a href='/support/hubrelay'>here</a>.</p>
              </React.Fragment>
            </div>
            </Dialog>
          </div>
          <div className="card flex justify-content-center">
            <Dialog 
              header="Session Expired - Please Login Again" 
              visible={showLoginModal} 
              style={{ width: '450px' }} 
              modal={true}
              closable={false}
              className="justify-content-center"
            >
              <p className="mb-3">Your session has expired. Please log in again to continue working without losing your form data.</p>
              <div className="flex justify-content-center">
                <Login onLoginSuccess={handleLoginSuccess} />
              </div>
            </Dialog>
          </div>
      </Container>
    <ScrollTop />
    </Card>
  );
};

export default SupportClients;
